module.exports = __webpack_public_path__ + "img/mx.ee70e6a6.svg";